import { type ArrayFieldTemplateProps } from '@rjsf/utils';

import { Button } from '@/shadcn/button';
import { cn } from '@/shadcn/lib/utils';
import { BadgePlus, Trash } from 'lucide-react';

export const ArrayFieldTemplate = ({
  title,
  items,
  canAdd,
  onAddClick,
  rawErrors
}: ArrayFieldTemplateProps) => {
  const error = rawErrors && rawErrors.length > 0;

  return (
    <div
      className={cn(
        'border-input rounded-md border p-2.5',
        error && 'border-destructive'
      )}
      data-has-error={error}
    >
      <div className="mb-3 text-base font-semibold">{title}</div>
      {items.map(item => (
        <div
          key={item.index}
          className="border-input mb-5 rounded-sm border p-3.5"
        >
          {item.children}
          {item.hasRemove && (
            <div className="flex flex-row justify-end">
              <Button
                variant="ghostDestructiveSubtle"
                size="icon"
                onClick={e => {
                  item.onDropIndexClick(item.index)(e);
                }}
              >
                <Trash />
              </Button>
            </div>
          )}
        </div>
      ))}
      {canAdd && (
        <Button onClick={onAddClick} variant="outline">
          <BadgePlus /> Add an item
        </Button>
      )}
    </div>
  );
};
